var ValueJS = ValueJS || {};

ValueJS.FontLoader = function() {

    var _initialized = false;

    var _interval;

    var _init = function() {
        if (!_initialized) {
            _interval = setInterval(_ready, 50);
        }
    }

    var _ready = function() {
        if (window['WebFont']) {
            clearInterval(_interval);
            _loadFonts();
        }
    }

    var _loadFonts = function() {
        WebFont.load({
            google: {
                families: [
                    'Tinos:italic',
                    'Tinos:400',
                    'Poppins:300,600'
                ]
            }
        });
        _initialized = true;
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

ValueJS.FontLoader.init();
